var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageToStudio = function SvgMessageToStudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FA",
    fillRule: "evenodd",
    d: "M4.166 5a.833.833 0 0 0-.833.833v11.322l1.91-1.91a.83.83 0 0 1 .59-.245h10a.833.833 0 0 0 .833-.833V5.833A.833.833 0 0 0 15.833 5zm-1.768-.934a2.5 2.5 0 0 1 1.768-.733h11.667a2.5 2.5 0 0 1 2.5 2.5v8.334a2.5 2.5 0 0 1-2.5 2.5H6.178l-3.09 3.089a.833.833 0 0 1-1.422-.59V5.834a2.5 2.5 0 0 1 .732-1.767",
    clipRule: "evenodd"
  })));
};
export default SvgMessageToStudio;